import { render } from "./PwdApproved.vue?vue&type=template&id=b1e7925a"
import script from "./PwdApproved.vue?vue&type=script&lang=js"
export * from "./PwdApproved.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__